export default __webpack_public_path__ + "static/media/ubelens-logo-white.4028e84a.png";